import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 8D8B924F-0AD5-4458-9BCE-0A5887D935B6
 * name skip-previous
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skip-previous.svg
 * tags
 * - Home Automation 
 */
export const SkipPreviousIcon = createSvgIcon(<><path d="M6,18V6H8V18H6M9.5,12L18,6V18L9.5,12Z" /></>, 'SkipPreviousIcon');
export default SkipPreviousIcon